export const video_orders = {
  path: "video-orders",
  reset: () => {},
};
